import { CommonModule, NgOptimizedImage } from "@angular/common";
import { Component, inject } from "@angular/core";

import { LoaderService } from "../../services";

@Component({
  selector: "adaa-spinner",
  imports: [CommonModule, NgOptimizedImage],
  templateUrl: "./spinner.html",
  styleUrl: "./spinner.scss",
})
export class SpinnerComponent {
  loaderService: LoaderService = inject(LoaderService);
}
